import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Content from "../pages/content/page";
import Wanghong from "../pages/content/wanghong/page";
import Fancha from "../pages/content/fancha/page";
import Jiudian from "../pages/content/jiudian/page";
import ContentDetail from "../pages/content/detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/content",
    element: <Content />,
  },
  {
    path: "/content/wanghong",
    element: <Wanghong />,
  },
  {
    path: "/content/fancha",
    element: <Fancha />,
  },
  {
    path: "/content/jiudian",
    element: <Jiudian />,
  },
  {
    path: "/content/:category/detail/:articleId",
    element: <ContentDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;